// Complete translations for COCON SACRÉ 2026 - Welcome Page
// /cocon-sacre-2026 (CoconSacre.jsx)

export const welcomeTranslations = {
  // META TAGS
  meta: {
    title: {
      fr: "Retraite transformation femme à Bali 2026 | Cocon Sacré",
      en: "Transformational Retreat in Bali 2026 | Cocon Sacré"
    },
    description: {
      fr: "Retraite transformation femme à Bali 2026. Immersion spirituelle en petit groupe de 6 femmes entre Gili, Bali et Java.",
      en: "A refined transformational retreat in Bali 2026. A small-circle immersive journey across Gili, Bali and Java."
    }
  },

  // NAVIGATION
  nav: {
    backToHome: {
      fr: "Retour à la page d'accueil",
      en: "Back to Home"
    }
  },

  // HERO SECTION
  hero: {
    subtitle: {
      fr: "RETRAITE INITIATIQUE",
      en: "INITIATORY RETREAT"
    },
    title: {
      fr: "COCON SACRÉ",
      en: "COCON SACRÉ"
    },
    tagline: {
      fr: "NAGE · PRIE · RAYONNE",
      en: "SWIM · PRAY · RADIATE"
    },
    // P0 Change 1: Hero phrase - traversée initiatique
    heroPhrase: {
      fr: "Une traversée initiatique en trois mouvements : nager, prier et rayonner.",
      en: "An initiatory journey in three movements: SWIM, PRAY and RADIATE."
    },
    location: {
      fr: "GILI MENO · BALI · JAVA",
      en: "GILI MENO · BALI · JAVA"
    },
    date: {
      fr: "MAI – JUIN 2026",
      en: "MAY – JUNE 2026"
    },
    enterSpace: {
      fr: "MON ESPACE SACRÉ",
      en: "MY SACRED SPACE"
    }
  },

  // WELCOME SECTION
  welcome: {
    title: {
      fr: "Bienvenue",
      en: "Welcome"
    },
    p1: {
      fr: "<strong>COCON SACRÉ</strong> est une <em>retraite initiatique à Bali</em>, pensée comme un espace de passage.",
      en: "<strong>COCON SACRÉ</strong> is an initiatory retreat in Bali, conceived as a space of passage."
    },
    p2: {
      fr: "Un voyage pour les âmes qui ressentent l'appel de ralentir,<br />de déposer, puis de rayonner autrement.",
      en: "A journey for souls who feel the quiet call to slow down,<br />to release what no longer belongs,<br />and to radiate differently."
    },
    p3: {
      fr: "Cette <em>immersion en Indonésie</em> se déploie en trois mouvements structurés,<br />dans un ordre précis, à travers différents territoires entre Gili, Bali et Java.",
      en: "This immersive experience unfolds through three intentional movements,<br />guiding the journey across distinct territories between Gili, Bali and Java."
    },
    p4: {
      fr: "Chaque étape soutient un déplacement intérieur réel.",
      en: "Each stage supports a tangible inner shift."
    },
    p5: {
      fr: "COCON SACRÉ n'est ni un séjour touristique, ni une retraite yoga classique.<br />C'est une traversée structurée, dédiée à l'alignement,<br />à la conscience et à la stabilité intérieure.",
      en: "COCON SACRÉ is a carefully held initiatory journey devoted to alignment,<br />clarity of consciousness and inner stability."
    },
    p6: {
      fr: "Conçue pour un cercle restreint, majoritairement féminin,<br />elle privilégie profondeur, qualité de présence et cohérence énergétique.",
      en: "Created for an intimate circle, predominantly feminine,<br />it honours depth, quality of presence and energetic coherence."
    }
  },

  // LANGUE & TRANSMISSION
  langueTransmission: {
    title: {
      fr: "Langue & Transmission",
      en: "Language & Transmission"
    },
    // P0 Change 4: Shortened language info text
    p1: {
      fr: "La retraite est transmise en français.<br />Des éditions anglophones seront proposées à partir de 2027.",
      en: "COCON SACRÉ is currently held in French.<br />English-speaking circles will open from 2027."
    },
    p2: {
      fr: "",
      en: ""
    },
    p3: {
      fr: "Le cercle s'élargit.<br />Le cœur reste précis.",
      en: "The circle expands.<br />The heart remains precise."
    }
  },

  // PRESENTATION SECTION
  presentation: {
    intro: {
      fr: "La page de présentation de <strong>COCON SACRÉ 2026</strong> expose la structure complète de la traversée :",
      en: "The complete presentation page of <strong>COCON SACRÉ</strong><br /><br />Here you will find the full architecture of the journey:"
    },
    list: {
      fr: [
        "l'arc initiatique",
        "les formats disponibles",
        "les lieux et hébergements confirmés",
        "les éléments inclus",
        "les modalités d'inscription"
      ],
      en: [
        "immersion details",
        "the three possible pathways",
        "practical information",
        "selected accommodations",
        "investment and application process"
      ]
    },
    // P0 Change 5: Reinforced invitation phrase
    invitation: {
      fr: "Si tu sens que le moment est là,<br />tu peux maintenant explorer l'espace COCON SACRÉ.",
      en: "If something within you opens while reading these lines,<br />you may now explore the COCON SACRÉ journey."
    },
    // P0 Change 6: CTA button - Explorer la retraite
    button: {
      fr: "J'explore la retraite",
      en: "Enter the Experience"
    }
  },

  // THREE MOVEMENTS
  movements: {
    nage: {
      title: { fr: "Nage", en: "SWIM" },
      location: { fr: "Gili Meno · du 25 au 28 mai", en: "Gili Meno · May 25 – 28" },
      p1: {
        fr: "Sur l'île de Gili Meno, le silence devient un seuil. Face à la mer, sans moteur, sans bruit, on se désencombre. On ralentit. On s'ouvre.",
        en: "On the island of Gili Meno, silence becomes a threshold. Facing the sea, without engines, without noise, we unburden. We slow down. We open."
      },
      p2: {
        fr: "L'immersion commence par une écoute profonde. Le corps dépose. L'esprit fait de l'espace.",
        en: "The immersion begins with deep listening. The body releases. The mind makes space."
      }
    },
    prie: {
      title: { fr: "Prie", en: "PRAY" },
      location: { fr: "Ubud & Pupuan · du 28 mai au 5 juin", en: "Ubud & Pupuan · May 28 – June 5" },
      p1: {
        fr: "À Ubud, le cœur devient le centre. Les journées sont tissées de pratiques incarnées, de rituels, de temples, de soins, de mouvements et de temps d'intégration.",
        en: "In Ubud, the heart becomes the center. The days are woven with embodied practices, rituals, temples, treatments, movements and integration time."
      },
      p2: {
        fr: "L'ouverture devient alignement. Le corps, le cœur et l'âme prient ensemble, dans le réel.",
        en: "Opening becomes alignment. Body, heart and soul pray together, in reality."
      }
    },
    rayonne: {
      title: { fr: "Rayonne", en: "RADIATE" },
      location: { fr: "Borobudur · du 6 au 9 juin", en: "Borobudur · June 6 – 9" },
      p1: {
        fr: "Face au plus grand temple bouddhiste du monde, le travail accompli prend sens. Les cercles se referment. L'intégration devient clarté.",
        en: "Facing the largest Buddhist temple in the world, the work accomplished takes meaning. The circles close. Integration becomes clarity."
      },
      p2: {
        fr: "On ne repart pas comme on est venu·e. On rayonne ce qui a été traversé. On incarne une nouvelle posture.",
        en: "We do not leave as we came. We RADIATE what has been crossed. We embody a new posture."
      }
    }
  },

  // TESTIMONIALS
  testimonials: {
    title: {
      fr: "Témoignages de transformation – Cocon Sacré 2025",
      en: "Transformation Stories – Cocon Sacré 2025"
    },
    christelle: {
      name: { fr: "Christelle", en: "Christelle" },
      text: {
        fr: "« COCON m'a permis de me reconnecter à l'essentiel. Les rituels, le cercle, la présence de Jeinar… tout était aligné. Je suis repartie plus ancrée, plus claire. Une expérience que je recommande à toute femme prête à se rencontrer vraiment. »",
        en: "\"COCON allowed me to reconnect with what truly matters. The rituals, the circle, Jeinar's presence… everything felt aligned. I left more grounded, more clear. An experience I recommend to any woman ready to truly meet herself.\""
      }
    },
    alexandra: {
      name: { fr: "Alexandra", en: "Alexandra" },
      text: {
        fr: "« Je ne savais pas ce que j'allais trouver. J'ai trouvé bien plus que ce que j'attendais. COCON n'est pas une retraite. C'est un passage. Merci pour cette profondeur. »",
        en: "\"I didn't know what I would find. I found far more than I expected. COCON is not a retreat. It is a passage. Thank you for this depth.\""
      }
    }
  },

  // FAQ
  faq: {
    title: {
      fr: "Questions fréquentes",
      en: "Frequently Asked Questions"
    },
    subtitle: {
      fr: "NAGE · PRIE · RAYONNE · 2026",
      en: "SWIM · PRAY · RADIATE · 2026"
    }
  },

  // FAQ ITEMS
  faqItems: [
    {
      question: {
        fr: "Qui est Jeinar, fondatrice de COCON ?",
        en: "Who is Jeinar, founder of COCON?"
      },
      answer: {
        fr: "",
        en: ""
      },
      isLinkOnly: true,
      linkTo: "/story/jeinar",
      linkText: {
        fr: "Découvrir Jeinar",
        en: "Discover Jeinar"
      }
    },
    {
      question: {
        fr: "Vocabulaire & étymologie",
        en: "Vocabulary & Meaning"
      },
      answer: {
        fr: "<strong>COCON</strong> : le cycle.\n\n<strong>coconé·e</strong> : toute personne ayant participé à une édition de COCON (année en cours ou éditions précédentes).\n\n<strong>coconeuse</strong> : femme-médecine ayant accompagné COCON (année en cours ou éditions précédentes).\n\nLe vocabulaire partage une même racine :\nCOCON.\n\nParce que le cercle est un tout.",
        en: "<strong>COCON</strong>: the cycle.\n\n<strong>Coconé·e</strong>: anyone who has participated in a COCON edition (current or previous years).\n\n<strong>Coconeuse</strong>: a woman-medicine who has accompanied COCON (current or previous editions).\n\nAll words share the same root:\nCOCON.\n\nBecause the circle is a whole."
      }
    },
    {
      question: {
        fr: "Qui sont les Coconeuses ?",
        en: "Who are the Coconeuses?"
      },
      answer: {
        fr: "UN ACCOMPAGNEMENT INCARNÉ\n\nLes Coconeuses sont des femmes profondément engagées dans le chemin vivant de la transformation.\n\nPour la plupart d'entre elles, ce travail se déploie depuis plus de vingt ans.\n\nLeurs approches peuvent différer.\nLeur présence, non.\n\nÉnergétique · Mouvement · Constellations · Intelligence émotionnelle · Spiritualité incarnée.\n\nElles ne performent pas.\nElles accompagnent.\n\nElles ne guident pas d'en haut.\nElles marchent à tes côtés.\n\nElles vivent sur place.\nPartagent les repas.\nSont présentes dans le silence.\nDans les rires.\nEt dans les passages plus denses de la traversée.\n\nIci, l'accompagnement n'est pas un service.\nC'est une responsabilité.\n\nQuatre Coconeuses sont déjà confirmées pour\nNAGE · PRIE · RAYONNE · 2026 :\n\n{{COCONEUSE_LINKS}}\n\nLe cercle continue de se former.\nD'autres présences seront annoncées prochainement.",
        en: "EMBODIED GUIDANCE\n\nThe Coconeuses are women deeply engaged in the living path of transformation.\n\nFor most of them, this work has been unfolding for more than twenty years.\n\nTheir approaches may differ.\nTheir presence does not.\n\nEnergy work · Movement · Constellations · Emotional awareness · Embodied spirituality.\n\nThey do not perform.\nThey accompany.\n\nThey do not guide from above.\nThey walk beside you.\n\nThey live on site.\nShare meals.\nAre present in silence.\nIn laughter.\nAnd in the denser passages of the journey.\n\nHere, guidance is not a service.\nIt is a responsibility.\n\nFour Coconeuses are already confirmed for\nSWIM · PRAY · RADIATE · 2026:\n\n{{COCONEUSE_LINKS}}\n\nThe circle continues to form.\nAdditional presences will be announced soon."
      },
      hasCoconeuses: true,
      coconeuses: ["jeinar", "stephanie", "valerie", "vanessa"],
      hasButton: true,
      buttonText: {
        fr: "Je découvre toutes les COCONEUSES",
        en: "Discover the Coconeuses"
      }
    },
    {
      question: {
        fr: "Est-ce une retraite \"perchée\" ?",
        en: "Is this a \"spiritually floating\" retreat?"
      },
      answer: {
        fr: "Non.\n\nCOCON est ancré.\nLes rituels sont vivants, structurés, respectueux des traditions locales.\n\nIl ne s'agit pas de s'échapper du réel.\nIl s'agit d'y revenir plus stable.",
        en: "No.\n\nCOCON is grounded.\nThe rituals are living, structured, and respectful of local traditions.\n\nThis is not about escaping reality.\nIt is about returning to it with greater stability."
      }
    },
    {
      question: {
        fr: "Est-ce une retraite yoga ?",
        en: "Is this a yoga retreat?"
      },
      answer: {
        fr: "Non.\n\nCertaines pratiques corporelles peuvent être proposées, mais COCON n'est pas centré sur la performance physique.\n\nIl s'agit d'alignement intérieur, pas d'enchaînements techniques.",
        en: "No.\n\nSome embodied practices may be offered,\nbut COCON is not centered on physical performance.\n\nIt is about inner alignment, not technical sequences."
      }
    },
    {
      question: {
        fr: "Faut-il être avancé.e ?",
        en: "Do I need prior experience?"
      },
      answer: {
        fr: "Non.\n\nIl n'y a aucun niveau requis.\n\nIl faut simplement être prêt·e à entrer dans une expérience sincère, structurée et engagée.\n\nLa traversée s'adapte à la maturité de chacun·e.",
        en: "No.\n\nThere is no required level.\n\nYou simply need to be ready to enter a sincere, structured, and committed experience.\n\nThe journey adapts to each person's maturity."
      }
    },
    {
      question: {
        fr: "Est-ce adapté si je viens seul·e ?",
        en: "Is it suitable if I come alone?"
      },
      answer: {
        fr: "Oui.\n\nLa majorité des coconé·e·s viennent seul·e·s.\n\nLe cercle restreint favorise la profondeur et la qualité de présence.\n\nOn ne se fond pas dans un groupe.\nOn entre dans un espace relationnel réel.",
        en: "Yes.\n\nMost participants come alone.\n\nThe intimate circle fosters depth and genuine relational space.\n\nYou do not dissolve into a group.\nYou enter a real human field."
      }
    },
    {
      question: {
        fr: "Et si je me sens submergé.e ?",
        en: "What if I feel overwhelmed?"
      },
      answer: {
        fr: "La traversée est contenue.\n\nChaque étape est pensée pour soutenir le système nerveux.\nLe cadre est stable, humain et structuré.\n\nLa profondeur est guidée.\nElle n'est jamais imposée.",
        en: "The journey is held.\n\nEach stage is designed to support the nervous system.\nThe container is stable, human, and structured.\n\nDepth is guided.\nNever imposed."
      }
    },
    {
      question: {
        fr: "Combien de coconé·e·s par édition ?",
        en: "How many participants per edition?"
      },
      answer: {
        fr: "Le nombre est volontairement limité.\n\nLa qualité du travail repose sur un cercle restreint.\n\nCOCON n'est pas un événement.\nC'est un espace qui ne se duplique pas.",
        en: "The number is intentionally limited.\n\nThe quality of the work relies on an intimate circle.\n\nCOCON is not an event.\nIt is a non-scalable space."
      }
    },
    {
      question: {
        fr: "Les hommes peuvent-ils participer ?",
        en: "Can men participate?"
      },
      answer: {
        fr: "Oui.\n\nCOCON est majoritairement féminin, mais reste ouvert aux hommes engagés dans une démarche sincère.\n\nLes cercles sont pensés avec respect et équilibre.",
        en: "Yes.\n\nCOCON is predominantly feminine,\nbut remains open to men engaged in a sincere inner process.\n\nCircles are held with respect and balance."
      }
    },
    {
      question: {
        fr: "Quelle est la différence entre les trois traversées ?",
        en: "What is the difference between the three pathways?"
      },
      answer: {
        fr: "COCON 2026 propose trois formats :\n\n• <strong>NAGE · PRIE · RAYONNE</strong> — l'arc complet\n• <strong>NAGE · PRIE</strong> — ouverture et ancrage\n• <strong>PRIE · RAYONNE</strong> — ancrage et consécration\n\nChaque parcours suit une progression réelle.\n\nRien n'est ajouté. Tout est orchestré.",
        en: "COCON 2026 offers three formats:\n\n• <strong>SWIM · PRAY · RADIATE</strong> — the complete arc\n• <strong>SWIM · PRAY</strong> — opening and grounding\n• <strong>PRAY · RADIATE</strong> — grounding and consecration\n\nEach pathway follows a real progression.\n\nNothing is added. Everything is orchestrated."
      }
    },
    {
      question: {
        fr: "Que comprend l'investissement ?",
        en: "What does the investment include?"
      },
      answer: {
        fr: "L'investissement inclut :\n\n• l'accompagnement continu\n• les pratiques et cérémonies\n• l'hébergement selon la formule choisie\n• les transferts internes prévus\n• l'organisation complète sur place\n\nLes vols internationaux ne sont pas inclus.",
        en: "The investment includes:\n\n• continuous guidance\n• rituals and structured practices\n• accommodation according to chosen option\n• internal transfers as scheduled\n• full on-site organization\n\nInternational flights are not included."
      }
    },
    {
      question: {
        fr: "Peut-on payer en plusieurs fois ?",
        en: "Is payment in installments possible?"
      },
      answer: {
        fr: "Oui.\n\nDes options de paiement échelonné sont proposées lors de l'inscription.\n\nL'engagement reste entier, même si le règlement est réparti.",
        en: "Yes.\n\nInstallment options are available during registration.\n\nThe commitment remains whole, even if payments are staggered."
      }
    },
    {
      question: {
        fr: "Que se passe-t-il en cas d'annulation ?",
        en: "What happens in case of cancellation?"
      },
      answer: {
        fr: "Les conditions d'annulation sont précisées lors de l'inscription.\n\nChaque réservation engage les hébergements et la logistique en amont.\n\nNous invitons chacun·e à souscrire une assurance adaptée.",
        en: "Cancellation terms are detailed during registration.\n\nEach booking secures accommodation and logistics in advance.\n\nWe recommend appropriate travel insurance."
      }
    },
    {
      question: {
        fr: "Les repas sont-ils adaptés aux régimes spécifiques ?",
        en: "Are meals adapted to specific diets?"
      },
      answer: {
        fr: "Oui.\n\nLes équipes locales s'adaptent aux besoins alimentaires signalés à l'avance.\n\nLa nourriture fait partie intégrante de l'expérience.",
        en: "Yes.\n\nLocal teams adapt to dietary needs communicated in advance.\n\nFood is an integral part of the experience."
      }
    },
    {
      question: {
        fr: "Pourquoi certain·e·s coconé·e·s reviennent ?",
        en: "Why do some participants return?"
      },
      answer: {
        fr: "COCON se vit.\nIl ne se consomme pas.\n\nÀ Valouse, en 2024, nous étions 11 pour la première édition.\n\nParmi ces 11 coconé·e·s :\n\n• 1 a choisi de rejoindre la première édition de COCON SACRÉ à Bali en 2025\n• 6 sont revenus à Valouse en 2025 pour la seconde édition\n\nRevenir n'est pas une habitude.\nC'est un signe.\n\nUn signe que l'expérience ne s'arrête pas à une semaine.\nQu'elle s'approfondit.\nQu'elle évolue avec la personne.\n\nEn 2026, nous nous réjouissons d'accueillir nos coconé·e·s fidèles —\ncelles et ceux qui deviennent, naturellement, les ambassadeurs vivants du Cocon.\n\nCe n'est pas une question de succès.\nC'est une question de profondeur.",
        en: "COCON is lived.\nIt is not consumed.\n\nIn Valouse 2024, we were 11 for the first edition.\n\nAmong them:\n\n• 1 joined the first Bali edition in 2025\n• 6 returned to Valouse in 2025\n\nReturning is not habit.\nIt is a sign.\n\nA sign that the experience does not end in a week.\nIt deepens.\nIt evolves with the person.\n\nIn 2026, we look forward to welcoming returning coconé·e·s —\nthose who naturally become living ambassadors of the circle.\n\nIt is not about success.\nIt is about depth."
      }
    },
    {
      question: {
        fr: "Comment réserver ma place pour 2026 ?",
        en: "How do I reserve my place for 2026?"
      },
      answer: {
        fr: "Choisis ta traversée.\n\nAccède à la billetterie.\n\nSélectionne ta formule (single ou double).\n\nRenseigne tes informations.\n\nTa place est confirmée immédiatement.\n\nLes places sont limitées afin de préserver la qualité du cercle.",
        en: "Choose your pathway.\n\nAccess the booking page.\n\nSelect your option (single or shared).\n\nEnter your information.\n\nYour place is confirmed immediately.\n\nSpaces are limited to preserve the integrity of the circle."
      }
    }
  ],

  // NEWSLETTER
  newsletter: {
    title: {
      fr: "RESTONS RELIÉ·E·S",
      en: "Let's Stay Connected"
    },
    description: {
      fr: "Pour recevoir les lettres du <span class='italic uppercase'>COCON</span>,<br />ou nous retrouver en ligne.",
      en: "Receive letters from <span class='italic uppercase'>COCON</span> in French<br />or follow the journey online."
    },
    placeholder: {
      fr: "Votre email",
      en: "Your email"
    },
    button: {
      fr: "S'inscrire",
      en: "Subscribe"
    },
    success: {
      fr: "Merci pour votre inscription !",
      en: "Thank you for subscribing."
    },
    error: {
      fr: "Une erreur est survenue. Veuillez réessayer.",
      en: "An error occurred. Please try again."
    }
  },

  // FOOTER
  footer: {
    copyright: {
      fr: "© 2024 Cocon. Tous droits réservés.",
      en: "© 2026 Cocon. All rights reserved."
    }
  },

  // FLOATING BUTTON - P0 Change 3: Voyage sonore
  floatingButton: {
    play: {
      fr: "Voyage sonore",
      en: "Sound journey"
    },
    pause: {
      fr: "Pause",
      en: "Pause"
    }
  },

  // EXPLORE BUTTON - P0 Change 2: Main button - Découvrir COCON SACRÉ
  exploreButton: {
    fr: "J'entre dans l'Expérience",
    en: "Enter the Experience"
  },

  // DIGITAL SPACE SECTION - Member area translations
  digitalSpace: {
    intro: {
      fr: "Cet espace est le COCON Numérique<br />qui accompagne les Coconeuses et les coconé·e·s<br />inscrit·e·s à COCON SACRÉ.",
      en: "This space is the COCON digital portal,<br />a private space for the Coconeuses and participants<br />walking the COCON SACRÉ journey."
    },
    enterButton: {
      fr: "MON ESPACE SACRÉ",
      en: "MY SACRED SPACE"
    },
    preCocon: {
      title: { fr: "PRÉ-COCON SACRÉ", en: "PRE-COCON SACRÉ" },
      description: { fr: "Pour que les âmes se préparent ensemble.", en: "A space for the circle to prepare together." }
    },
    cocon: {
      title: { fr: "COCON SACRÉ", en: "COCON SACRÉ" },
      description: { fr: "Pour accueillir ce qui se vit sur place.", en: "A space to welcome what unfolds during the retreat." }
    },
    postCocon: {
      title: { fr: "POST-COCON SACRÉ", en: "POST-COCON SACRÉ" },
      description: { fr: "Pour l'intégration.", en: "A space for integration." }
    }
  }
};

export default welcomeTranslations;
